import { Button, Card, ConfigProvider, Flex, Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import "./CollecteazeAI.scss";

import { HistoryOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { createChatSession, deleteChatSession, sendChatMessage, updateSessionArchiveStatus, uploadDocument } from "../../assets/api/collecteazeAi";
import ChatBox from "../../components/AIPageComponent/ChatBox/ChatBox";
import HistoryComp from "../../components/AIPageComponent/HistoryComp/HistoryComp";
import MessageInput from "../../components/AIPageComponent/MessageInput/MessageInput";
import PromptMessage from "../../components/AIPageComponent/PromptMessage/PromptMessage";
import ResponseMessage from "../../components/AIPageComponent/ResponseMessage/ResponseMessage";
import { appendCurrentMessage, fetchArchiveSessionsList, fetchSessionsList, fetchSessionsMessages, setCurrentSession } from "../../store/collecteazeAiSlice";
import toast from "react-hot-toast";

const CollecteazeAI = () => {
  const [size, setSize] = useState("large");
  const [chatHistory, setChatHistory] = useState([]);
  const [pastSessions, setPastSessions] = useState([]);
  const [currentSessionId, setCurrentSessionId] = useState(Date.now());
  const [isChatBoxVisible, setIsChatBoxVisible] = useState(true);
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [loadedSessionId, setLoadedSessionId] = useState(null);
  const [showArchived, setShowArchived] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const { current_session } = useSelector(state => state.collecteazeAi)
  const chatContentRef = useRef(null);
  const messageInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const { messages_loading, all_messages } = useSelector(state => state.collecteazeAi);
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);



  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [all_messages]);



  const handleSendMessage = async (text, file) => {


    const userMessage = {
      msg_id: uuid(),
      sender: "user",
      timestamp: new Date().toISOString(),
      sessionId: current_session,
    };
    dispatch(appendCurrentMessage(userMessage));

    setChatHistory((prev) => [...prev, userMessage]);
    setIsChatBoxVisible(false);
    return;

  };



  const handleChatBoxButtonClick = async (text, file) => {
    if (!text.trim()) return; // prevent sending empty messages

    // Create user message
    const userMessage = [
      {
        message_id: uuid(),
        role: "user",
        timestamp: new Date().toISOString(),
        message: text,
      },
      {
        message_id: uuid(),
        role: "bot",
        timestamp: new Date().toISOString(),
        message: 'We encountered an issue. Please refresh or try again.',
        is_dummy: true
      },
    ]


    dispatch(appendCurrentMessage(userMessage));
    setIsLoading(true)

    try {
      // Send message to backend
      const res = await sendChatMessage(
        {
          session_id: current_session,
          user_id: user?.email,
          message: text,
        },
        token
      );

      // Fetch updated messages only if successful
      if (res?.status === 200) {
        dispatch(fetchSessionsMessages({ session_id: current_session }));
        setIsLoading(false)
      } else {
    
        setIsLoading(false)

      }
    } catch (error) {
      console.error("Error sending message:", error);
      setIsLoading(false)

    }
  };





  const handleNewChat = () => {

    dispatch(setCurrentSession(null));
    setIsHistoryVisible(false);
  };

  const handleSelectSession = (sessionId) => {
    dispatch(setCurrentSession(sessionId));
    setIsHistoryVisible(false)

  };

  const handleRenameSession = (sessionId, newTitle) => {

  };

  const handleArchiveSession = async (sessionId, status) => {
   setLoading(true);
    try {
      const res = await updateSessionArchiveStatus({
        session_id: sessionId,
        archived: status,
        token,
      })
     
      if (res?.status === 200) {
        toast.success(res?.data?.message || "Session archived successfully");
        setLoading(false);
        dispatch(fetchSessionsList({ user_id: user?.email }));
        dispatch(fetchArchiveSessionsList({ user_id: user?.email }));
      }
    } catch (error) {
      console.error("Error archiving session:", error);
      setLoading(false);
      toast.error("Failed to archive session");

    }
  };

  const handleUnarchiveSession = (sessionId) => {

  };

  const handleDeleteSession = async (sessionId) => {
try {
  const res = await deleteChatSession({
    session_id: sessionId,
    token,
  })
  if(res?.status === 200) {
    toast.success("Session deleted successfully");
    dispatch(fetchSessionsList({ user_id: user?.email }));
    dispatch(fetchArchiveSessionsList({ user_id: user?.email }));
  }
 
} catch (error) {
  
}
  };

  useEffect(() => {
    if (chatContentRef.current) {
      chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
    }
  }, [chatHistory]);

  const dispatch = useDispatch();
  const fetchSessions = async () => {
    try {
      const res = await createChatSession({ user_id: user?.email }, token);
      if (res?.status === 200) {
        dispatch(setCurrentSession(res?.data?.data?.session_id))
      }
    } catch (error) {
      console.error('Error fetching chat sessions:', error);
    }
  };

  useEffect(() => {
    if (current_session !== null && current_session !== undefined) {
      dispatch(fetchSessionsMessages({ session_id: current_session }))
    }
    if (current_session === null) {
      fetchSessions();
    }
  }, [current_session]);

  const handleReload = (session_id, message_id) => {

  }

  const wrapperStyle = {
    borderRadius: 8,
    overflow: "hidden",
    width: "100%",
    maxWidth: "1287px",
    height: "100%",
    minHeight: "740px",
    backgroundColor: "#fff",
    margin: "0 auto",
  };
  const contentWrapper = {
    padding: "10px",
  };


  const handleFileChange = async (fileList) => {

    if (fileList?.length <= 0) {
      return;
    }
    const res = await uploadDocument({
      files: fileList[0]?.originFileObj,
      session_id: current_session
    }, token)

    if (res?.status === 200) {
      dispatch(fetchSessionsMessages({ session_id: current_session }));
    }
  };

  return (
    <Card className="insightWrapper_Main" style={wrapperStyle}>
      <Card className="insightContainer_button">
        <Flex gap="small" wrap style={contentWrapper}>
          <ConfigProvider
            theme={{
              token: {},
              components: {
                Button: {
                  defaultBg: "#212121",
                  defaultHoverBg: "#212121",
                  borderRadius: 6,
                },
              },
            }}
          >
            <Button
              type="primary"
              icon={<HistoryOutlined />}
              size={size}
              onClick={() => setIsHistoryVisible(true)}
            />
          </ConfigProvider>
        </Flex>

        <Modal
          className="modalWrapper_"
          open={isHistoryVisible}
          onCancel={() => setIsHistoryVisible(false)}
          footer={null}
          closable={false}
          maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
          bodyStyle={{
            padding: 0,
            background: "transparent",
            boxShadow: "none",
          }}
          centered
          width={301}
        >
          <HistoryComp
            onClose={() => setIsHistoryVisible(false)}
            onNewChat={handleNewChat}
            onSelectSession={handleSelectSession}
            onRenameSession={handleRenameSession}
            onArchiveSession={handleArchiveSession}
            onUnarchiveSession={handleUnarchiveSession}
            onDeleteSession={handleDeleteSession}
            pastSessions={pastSessions}
            showArchived={showArchived}
            setShowArchived={setShowArchived}
            archiveLoading={loading}
          />
        </Modal>
      </Card>

      <Card
        className="chatContentWrapper"
        style={{ overflowY: "auto", maxHeight: "700px", minHeight: "570px" }}
        ref={chatContentRef}
      >
        {(current_session === null || all_messages?.length <= 0) && (
          <ChatBox onButtonClick={handleChatBoxButtonClick} handleFileChange={handleFileChange} />
        )}
        <Flex vertical gap="middle" className="chatBoxWrappedSect" style={{ overflowY: 'auto', maxHeight: '100%' }}>
          {all_messages?.map((msg) => (
            <Flex key={msg.message_id} vertical className="chatBox_C">
              {msg.role === "user" ? (
                <PromptMessage msg={msg} className="prompt_box_" />
              ) : (
                <ResponseMessage msg={msg} className="response_box_" loading={isLoading} handleReload={handleReload} />
              )}
            </Flex>
          ))}
          {/* Invisible anchor to scroll into view */}
          <div ref={bottomRef} />
        </Flex>

      </Card>

      <MessageInput
        onSend={handleSendMessage}
        ref={messageInputRef}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </Card>
  );
};

export default CollecteazeAI;
